import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import ButtonTitle from "../../components/ButtonTitle";
import { useParams } from "react-router-dom";
import { convertToSlug } from "../../utils/helps";
import { HomeIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

function Notification() {
  const posts = useSelector((state) =>
    state.posts?.posts?.filter((post) => post.status === "published"),
  )?.filter(
    (post) =>
      post.type === "notification" &&
      post.category?.name !== "Điều khoản" &&
      post.category?.name !== "Giới thiệu",
  );
  // const { navbars } = useSelector((state) => state.categories);
  const { slug } = useParams();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const groupPostsByCategory = (posts) => {
    let filteredPosts = posts;

    // if (!slug) {
    //   const navbarCategories = new Set(navbars.map((item) => item.name));
    //   filteredPosts = posts.filter(
    //     (post) => !navbarCategories.has(post?.category?.name),
    //   );
    // }

    return filteredPosts.reduce((acc, post) => {
      const categoryName = post?.category?.name || "Chưa phân loại";
      if (!acc[categoryName]) {
        acc[categoryName] = [];
      }
      acc[categoryName].push(post);
      return acc;
    }, {});
  };

  const groupedPosts = groupPostsByCategory(posts);

  const displayedCategories = slug
    ? Object.keys(groupedPosts).filter(
        (categoryName) => convertToSlug(categoryName) === slug,
      )
    : Object.keys(groupedPosts);

  return (
    <div className="container mx-auto">
      <nav className="flex text-gray-500 text-sm mb-4" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2">
          <li className="inline-flex items-center">
            <Link
              to="/"
              className="inline-flex items-center hover:text-blue-600 font-medium"
            >
              <HomeIcon className="w-4 h-4 mr-2 text-gray-400" />
              Trang chủ
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <svg
                className="w-3 h-3 mx-2 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>
              <span className="ml-1 text-gray-400 font-medium">
                Đăng ký hoạt động
              </span>
            </div>
          </li>
        </ol>
      </nav>
      <h1 className="text-[24px] font-bold">Đăng ký hoạt động</h1>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mt-3 mb-2">
        <div className="md:col-span-12 col-span-12">
          {displayedCategories?.length > 0 ? (
            displayedCategories.map((categoryName) => (
              <div key={categoryName} className="mb-6">
                <h2 className="font-bold text-[21px] mb-4">
                  <ButtonTitle title={categoryName} />
                </h2>
                <div className="space-y-4">
                  {groupedPosts[categoryName]?.map((article) => (
                    <div
                      key={article.id}
                      className="p-4 bg-base-100 rounded-lg shadow-md border border-gray-200 hover:shadow-lg transition-shadow"
                    >
                      <Link
                        to={`${article.category?.slug}/${article.slug}`}
                        className="text-[16px] font-semibold"
                      >
                        {article.title}
                      </Link>
                      <div className="mt-2 text-[16px] text-gray-500 flex items-center">
                        <span className="mr-2">✍️</span>
                        <span>
                          Người tạo: {article.user?.userFullName || "Ẩn danh"}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <p className="text-center">Không có bài viết</p>
          )}
        </div>

        {/* <div className="md:col-span-4 col-span-12">
          <div className="sticky top-[80px]">
            <ButtonTitle title="Đăng ký tham gia" />
            <BusinessForm />
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default Notification;
